import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { PerioTooth } from '../models/perio.models';
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PerioService {

  constructor(private http: HttpClient) { }

  getChartList(patientID: string): Observable<any> {
    return this.http.get('/api/perio/GetPerioChartList/' + patientID);
  }

  getControlConfig() {
    let promise = new Promise((resolve, reject) => {
      const config = require('../models/perio.config.json');
      resolve(config);
    });
    return promise;
  }

  getControlSetupList(): Observable<any> {
    return this.http.get('/api/perio/GetControlSetupList/');
  }

  getValidationParams(): Observable<any> {
    return this.http.get('/api/perio/GetPerioValidationParameters/');
  }

  getPerioTeethApi(perioChartID: string): Observable<any> {
    return this.http.get('/api/perio/GetPerioChartTeeth/' + perioChartID);
  }

  getPerioTeethIdByCaseWorkItemForm(CaseWorkItemForm: string): Observable<any> {
    return this.http.get('/api/perio/GetPerioTeethIdByCaseWorkItemForm/' + CaseWorkItemForm);
  }

  savePerioTooth(tooth: PerioTooth): Observable<any> {
    return this.http.post('/api/perio/savePerioTooth', tooth);
  }

  // api/perio/CreateNewPerioTeethChart/{PatientID}/{caseWorkItemFormsId}
  createNewPerioTeethChart(patientID: string, caseWorkItemFormsId: string): Observable<any> {
    return this.http.get('/api/perio/CreateNewPerioTeethChart/' + patientID + '/' + caseWorkItemFormsId);
  }

}
